import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { ToastsStore } from '@bnsf/bnsf-react-toast-messages';
import Select from 'react-select';
import { setDataReload } from '../../../redux/actions/setDataReload';
import { VIEW } from '../../../constants/appConstants';
import WindowCard from '../../WindowCard';
import WindowCopy from '../../WindowCopy';
import YesNoModal from '../../Modals/YesNoModal';
import { 
    getRejectionCodes,
    getWindowRequests, 
    getWindowRequestsByRequestorId,
    copyWindowRequest,
    deleteWindowRequest,
    validateWindowRequest
} from '../../../services/trackWindow';
import { FILTER_OPTIONS_ALL, FILTER_OPTIONS_MY } from './constants';
import { getDateRangeByFilter } from '../../../utils/filtersUtil';

import TrackWindow from '../../../model/TrackWindow';
import Domain from '../../../model/Domain';

import './WindowListView.css';

import ViolationModal from '../../GuidelineViolation/ViolationModal';
let __rejection_codes = null;

const WindowListView = (props) => {
    const [ selectedList, setSelectedList ] = useState('ALL');
    const [ windows, setWindows ] = useState([]);
    const [ filteredWins, setFilteredWins ] = useState([]);
    const [ showCopy, setShowCopy ] = useState(false);
    const [ winToDelete, setWinToDelete ] = useState(null);
    const [ winToCopy, setWinToCopy ] = useState(null);
    const [ showViolations, setShowViolations ] = useState(false);
    const [ violationsToModal, setViolationsToModal ] = useState([]);

    let violations = [];
    let processedDatesToCopy = [];
    let violationDatesToCopy = [];

    useEffect(() => {
        fetchRejectionCodes();
    }, []);

    useEffect(() => {        
        if (props.dataReload) {
            props.view.current === VIEW.MY_WINDOW_VIEW ? fetchMyWindows() : fetchWindows();
        }        
    }, [ props.dataReload ]);

    const fetchMyWindows = () => {
        const winFilter = props.windowFilter[props.view.current];
        const dateRange = getDateRangeByFilter(winFilter);
        const req = {
            requestorId: props.userProfile.sub,
            startDate: dateRange.startDate, 
            endDate: dateRange.endDate,
            gangIds: winFilter.gangIds.length > 0 ? winFilter.gangIds.join('/') : ''
        };

        getWindowRequestsByRequestorId(req).then(resp => {
            let wins = resp;

            // filter the response by gang ids
            const winFilter = props.windowFilter[props.view.current];
            if (winFilter.gangIds.length > 0) {
                wins = resp.filter(win => winFilter.gangIds.some(gangId => win.gangIds.includes(gangId)));
            }

            onQueryCompleted(wins);
        }, onMyWindowQueryFailure);
    } 

    const onMyWindowQueryFailure = (err) => {
        ToastsStore.showToast("MY_WINDOW_QUERY_FAILURE");
        console.error(err);
    }

    const fetchWindows = () => {
        const winFilter = props.windowFilter[props.view.current];
        const dateRange = getDateRangeByFilter(winFilter);
        const req = {
            division: props.selectedDiv,
            subdivisions: props.selectedSubdivs,
            startDate: dateRange.startDate, 
            endDate: dateRange.endDate,
            gangIds: winFilter.gangIds.length > 0 ? winFilter.gangIds.join('/') : '',
            windowStatus: props.isAuthorized ? 'A,P' : 'A'
        };

        getWindowRequests(req).then(onQueryCompleted, onWindowQueryFailure);
    } 

    const onWindowQueryFailure = (err) => {
        ToastsStore.showToast("WINDOW_QUERY_FAILURE");
        console.error(err);
    }

    const fetchRejectionCodes = () => {
        getRejectionCodes().then(rejectionCodes => {
            if (Array.isArray(rejectionCodes) && rejectionCodes.length > 0) {
                __rejection_codes = new Domain(rejectionCodes);
            } 
        }, onRejectionCodeFailure);
    }

    const onRejectionCodeFailure = (err) => {
        ToastsStore.showToast("REJECTION_CODE_FAILURE");
        console.error(err);
    }

    const onQueryCompleted = (wins) => {
        if (__rejection_codes) {
            wins.forEach(win => {
                if (win.isRejected) {
                    win.rejectionCode = __rejection_codes.toName(win.rejectionCode) || win.rejectionCode;
                }
            });
        }

        const sortedWins = wins.sort(TrackWindow.compare);
        setWindows([...sortedWins]);
        setFilteredWins([...sortedWins]);

        props.setDataReload(false);
    }

    const copyWindow = (aWin) => {
        setWinToCopy(aWin);
        setShowCopy(true);
        console.log("COPY: " + JSON.stringify(aWin));
    };

    const onHide_copyWindow = () => setShowCopy(false);

    const validateWindowsByDate = (datesToCopy) => {
        var count = 0;

        datesToCopy.forEach((aDate) => {
            let newWin = winToCopy.clone();
            newWin.startDate = aDate;

            if (newWin.trkWinReqId) {
                delete newWin.trkWinReqId;
            }

            validateWindowRequest(newWin).then((res) => {
                onValidationSuccess(res, aDate).then(()=>{
                    count++;
                    if (count === datesToCopy.length) {
                        processAfterValidation();
                    }
                });
            }, onValidationFailure);
        });
    }

    const onValidationSuccess = (resp, aDate) => {
        return new Promise((resolve, reject)=> {
            if (resp.windowValid || (resp.totalViolations > 0 && resp.violations.filter((r) => r.warningType === "Hard").length === 0)) {
                processedDatesToCopy = processedDatesToCopy.concat(aDate);
            } else {
                violationDatesToCopy = violationDatesToCopy.concat(aDate);
                let newViolation = resp.violations.filter((resViol) => 
                    resViol.warningType !== "Soft" && 
                    !violations.some((existingViol) =>
                        JSON.stringify(resViol) === JSON.stringify(existingViol)
                    )
                );
               
                violations = violations.concat(newViolation);
             }
 
            if ((Array.isArray(processedDatesToCopy) && processedDatesToCopy.length > 0)
                    || (Array.isArray(violationDatesToCopy) && violationDatesToCopy.length > 0)) {
                resolve();
            }
        });
    }
 
    const onValidationFailure = (err) => {
        ToastsStore.showToast("VALIDATION_FAILURE");
        console.error(err);
    }

    const processAfterValidation = () => {
        if (Array.isArray(violationDatesToCopy) && violationDatesToCopy.length > 0) {
            var violationMessage = {
                ruleId: 3,
                message: `Windows not copied on :  ${violationDatesToCopy.sort().join(', ')}`,
                warningType: "Hard"
            };

            violations = violations.concat(violationMessage);

            if (Array.isArray(processedDatesToCopy) && processedDatesToCopy.length > 0) {
                var processedMessage = {
                    ruleId: 3,
                    message: `Windows successfully copied on :  ${processedDatesToCopy.sort().join(', ')}`,
                    warningType: "Success"
                };

                violations = violations.concat(processedMessage);
            }

            setViolationsToModal(violations);
            setShowCopy(false);
            setShowViolations(true);
        }

        if (Array.isArray(processedDatesToCopy) && processedDatesToCopy.length > 0) {
            setShowCopy(false);
            sendWinCopyRequest(processedDatesToCopy);
        }
    }

    const onCopy_copyWindow = (datesToCopy) => {
        if (winToCopy.winType === 'TW') {
            sendWinCopyRequest(datesToCopy);
        } else {
            // validate window against division guidelines
            validateWindowsByDate(datesToCopy);
        }
    }

    const sendWinCopyRequest = (datesToCopy) => {
        copyWindowRequest(winToCopy, datesToCopy, props.userProfile).then(onCopySuccess, onCopyFailure);
    }

    const onCopySuccess = (resp) => {
        if (resp.returnCode === '0') {
            console.info('Successfully copied window');
            ToastsStore.showToast("COPY_SUCCESS");

            setWinToCopy(null);
            setShowCopy(false);
            props.setDataReload(true);
        }
        else {
            console.error(`Failed to copy window, ${winToCopy.objectId}`);
            console.error(resp);
            ToastsStore.showToast("COPY_FAILURE");
        }
    }

    const onCopyFailure = (err) => {
        console.error(`Failed to copy window, ${winToCopy.objectId}`);
        console.error(err);
        ToastsStore.showToast("COPY_FAILURE");
    }

    const editWindow = (aWin) => {
        console.log("EDIT: " + JSON.stringify(aWin));

        props.switchView && props.switchView(VIEW.WINDOW_EDIT_VIEW, { winToEdit: aWin });
    };

    const deleteWindow = (aWin) => {
        console.log("DELETE: " + JSON.stringify(aWin));
        
        setWinToDelete(aWin);
    };

    const onYes_deleteModal = () => {        
        deleteWindowRequest(winToDelete.objectId, props.userProfile).then(
            onDeleteSuccess, 
            onDeleteFailure
        );       
    };

    const onDeleteSuccess = resp => {
        if (resp.returnCode === '0') {
            console.info(`Successfully deleted window, ${winToDelete.objectId}`);

            ToastsStore.showToast("DELETE_SUCCESS");

            setWinToDelete(null);
            props.setDataReload(true);
        }
        else {
            console.warn(`Failed to delete window, ${winToDelete.objectId}`);

            ToastsStore.showToast("DELETE_FAILURE");
        }
    };

    const onDeleteFailure = () => {
        ToastsStore.showToast("DELETE_FAILURE");
    }

    const onNo_deleteModal = () => {
        setWinToDelete(null);
    }

    const winItems = filteredWins.map((aWin, idx) => 
        <WindowCard key = { idx } 
            data = { aWin } 
            editWindow = { editWindow } 
            copyWindow = { copyWindow } 
            deleteWindow = { deleteWindow } />
    );

    const noWinItem = props.dataReload ? (
        <div className='clsNoWin'>
            Querying windows...
            <div className="progress indeterminate">
                <div className="progress-bar"></div>
            </div>
        </div>
    ) : (
        <div className='clsNoWin'>
            No window returned from the query.
        </div>
    );

    const filterList = (value) => {
        let newFilteredWins = windows.filter(aWin => {
            const isMyWin = aWin.isMyWindow(props.userProfile.sub.toUpperCase());

            switch (value) {
                case 'ALL': return 1;
                case 'APPROVED': return aWin.isApproved();
                case 'MY_APPROVED': return isMyWin && aWin.isApproved();
                case 'MY_PENGING': return isMyWin && aWin.isPending();
                case 'MY_REJECTED': return isMyWin && aWin.isRejected();
                case 'MY_CANCELED': return isMyWin && aWin.isCancelled();
                case 'OTHERS': return !isMyWin;
                default: return false;
            }
        });

        setFilteredWins(newFilteredWins);
        setSelectedList(value);
    };

    const onClick_changeSubdiv = () => {
        props.switchView && props.switchView(VIEW.HOME_VIEW);
    };

    const subdivItem = props.view.current === VIEW.WINDOW_LIST_VIEW ? (
        <div className='clsSubWrapper'>
            <div className='clsSubValueWrapper'>
                <span className='clsSubLabel'>Subdivision</span>
                <span className='clsSubValue'>{ props.selectedSubdivs.join(', ') }</span>
            </div>
            <div className='clsSubChange' onClick={ onClick_changeSubdiv }>CHANGE</div>
        </div>
    ) : null;

    const filterOptions = props.view.current === VIEW.WINDOW_LIST_VIEW ? 
        FILTER_OPTIONS_ALL : FILTER_OPTIONS_MY;

    return (
        <div className='clsWinListView'>
            { subdivItem }

            { props.isAuthorized ? 
                <div className='clsListFilter'>
                    <Select 
                        options = { filterOptions } 
                        noOptionsMessage = { () => 'No Result Found' }
                        value = { selectedList } 
                        onChange = { (selected) => filterList(selected.value) } />
                </div>
                : null
            }

            <div className='clsWinList'>
                { winItems.length > 0 ? winItems : noWinItem }
            </div>  

            { showCopy ? <WindowCopy show = { true } 
                onHide = { onHide_copyWindow } 
                onCopy = { onCopy_copyWindow } /> : null }

            { winToDelete ? <YesNoModal title='WARNING'
                message = 'Are you sure you want to delete the window?' 
                onNo = { onNo_deleteModal } 
                onYes = { onYes_deleteModal } /> : null}

            {showViolations ? <ViolationModal violations = { violationsToModal } onProceed = { ()=> {} } /> : null}
        </div>
    );
}

const mapStateToProps = state => {
    return {
        view: state.view,
        dataReload: state.dataReload.reload,
        userProfile: state.oidc.user && state.oidc.user.profile,
        isAuthorized: state.isAuthorized,
        windowFilter: state.windowFilter,
        selectedDiv: state.windowQuery.selectedDivision,
        selectedSubdivs: state.windowQuery.selectedSubdivisions
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setDataReload: (reload) => dispatch(setDataReload(reload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WindowListView);